import { isDarkHex, resolveRoleColor } from "./surfStyle.js";
export const SURF_PREVIEW_SAMPLE = {
    kicker: "ANTEPRIMA STILE",
    title: "Titolo di esempio",
    subtitle: "Sottotitolo che mostra la gerarchia tipografica",
    body: "Corpo del testo campione per verificare leggibilità su sfondo generato. Il contrasto e lo scrim devono rendere tutto leggibile.",
};
export function surfPreviewLayers(style, presentationType) {
    const sample = previewSampleForPresentationType(presentationType);
    const safe = style.legibility.safeZones[0] ?? { x: 0.08, y: 0.12, w: 0.84, h: 0.76 };
    const specs = [
        { role: "kicker", text: sample.kicker, y: safe.y, h: 0.06 },
        { role: "title", text: sample.title, y: safe.y + 0.07, h: 0.14 },
        { role: "subtitle", text: sample.subtitle, y: safe.y + 0.22, h: 0.08 },
        { role: "body", text: sample.body, y: safe.y + 0.32, h: 0.38 },
    ];
    return specs.map(({ role, text, y, h }) => {
        const tr = style.textRoles[role];
        const color = resolveRoleColor(style, role);
        return {
            role,
            text,
            rect: { x: safe.x, y, w: safe.w, h },
            style: {
                fontFamily: tr.font,
                fontWeight: tr.weight,
                fontSize: `${(tr.sizeRel * 100).toFixed(1)}cqh`,
                color,
                textAlign: tr.align,
                lineHeight: tr.lineHeight,
                letterSpacing: tr.tracking ? `${tr.tracking}em` : undefined,
                textTransform: tr.case === "upper" ? "uppercase" : undefined,
                margin: 0,
            },
        };
    });
}
export function surfPreviewBackgroundStyle(style, previewImageUrl, solidColor) {
    if (previewImageUrl) {
        return {
            backgroundImage: `url(${previewImageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        };
    }
    const hex = solidColor?.trim();
    if (hex && /^#[0-9A-Fa-f]{6}$/i.test(hex)) {
        return { background: hex.toUpperCase() };
    }
    const dark = isDarkHex(style.palette.surface);
    const accent = style.palette.accent;
    return {
        background: `linear-gradient(135deg, ${style.palette.surface} 0%, ${accent}22 55%, ${dark ? "#000" : style.palette.muted}88 100%)`,
    };
}
export function surfPreviewScrimStyle(style) {
    const leg = style.legibility;
    if (leg.strategy === "scrim" || leg.strategy === "box") {
        const scrim = leg.scrim ?? { color: "#000000", opacity: 0.35, blur: 0 };
        return {
            backgroundColor: scrim.color,
            opacity: scrim.opacity,
            backdropFilter: scrim.blur ? `blur(${scrim.blur}px)` : undefined,
        };
    }
    if (leg.strategy === "safezone" && leg.autoContrast) {
        return {
            background: `linear-gradient(180deg, transparent 0%, ${style.palette.surface}22 100%)`,
        };
    }
    return null;
}
/** F24 — quick contrast sanity check for preview sample text on surface. */
export function isSurfPreviewLegible(style) {
    const darkBg = isDarkHex(style.palette.surface);
    const titleColor = style.textRoles.title.color;
    const titleDark = isDarkHex(titleColor);
    if (darkBg === titleDark && style.legibility.autoContrast)
        return true;
    if (darkBg && !titleDark)
        return true;
    if (!darkBg && titleDark)
        return true;
    return style.legibility.strategy !== "safezone" || style.legibility.autoContrast;
}
export function previewSampleForPresentationType(presentationType) {
    const type = presentationType?.trim().toLowerCase() ?? "";
    if (type === "executive") {
        return {
            kicker: "EXECUTIVE BRIEF",
            title: "Decisione in 30 secondi",
            subtitle: "Sintesi per il comitato",
            body: "Tre insight chiave. Nessun muro di testo.",
        };
    }
    if (type === "educativo") {
        return {
            kicker: "MODULO 1",
            title: "Concetto chiave",
            subtitle: "Definizione in una riga",
            body: "Spiegazione didattica breve con esempio concreto.",
        };
    }
    return SURF_PREVIEW_SAMPLE;
}
